/**
 * Guards the ISO 3166-1 alpha-2 code the API exposes as `country.code`.
 * Returns the upper-cased code, or null when the value is not a 2-letter code.
 *
 * @param {String} rawCode
 * @returns {String|null}
 */
const parseCountryIso2 = (rawCode) => {
  if (typeof rawCode !== 'string') return null;
  const trimmed = rawCode.trim();
  return /^[a-z]{2}$/i.test(trimmed) ? trimmed.toUpperCase() : null;
};

export default parseCountryIso2;
